const translation = {
  // Navigation
  nav: {
    discover: 'Discover',
    messages: 'Messages',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
  },
  
  // Home/Landing
  home: {
    title: 'Find Your Perfect Match',
    subtitle: 'Connect with people from around the world. Free forever.',
    getStarted: 'Get Started',
    features: {
      title: 'Why Choose Love Connect Globimeet?',
      free: {
        title: 'Completely Free',
        description: 'All features are free. No hidden costs.',
      },
      global: {
        title: 'Global Connections',
        description: 'Meet people from every country.',
      },
      safe: {
        title: 'Safe & Secure',
        description: '18+ age verification and profile photo required.',
      },
      translate: {
        title: 'Auto Translation',
        description: 'Chat in any language with built-in translation.',
      },
      video: {
        title: 'Voice & Video Calls',
        description: 'Make free calls directly on the platform.',
      },
      inclusive: {
        title: 'Inclusive for Everyone',
        description: 'All genders and orientations welcome.',
      },
    },
  },
  
  // Auth
  auth: {
    login: 'Login',
    register: 'Sign Up',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    name: 'Name',
    birthdate: 'Date of Birth',
    gender: 'Gender',
    lookingFor: 'Looking For',
    country: 'Country',
    city: 'City',
    profilePhoto: 'Profile Photo',
    uploadPhoto: 'Upload Photo',
    agreeTerms: 'I agree to the Terms and Conditions',
    mustBe18: 'You must be 18 or older',
    photoRequired: 'Profile photo is required',
    genders: {
      male: 'Male',
      female: 'Female',
      gay: 'Gay',
      lesbian: 'Lesbian',
      trans: 'Trans',
      other: 'Other',
    },
    lookingForOptions: {
      everyone: 'Everyone',
      men: 'Men',
      women: 'Women',
      friends: 'Friends',
      dating: 'Dating',
      serious: 'Serious Relationship',
    },
  },
  
  // Discover
  discover: {
    title: 'Discover',
    noMoreProfiles: 'No more profiles to show',
    filters: 'Filters',
    ageRange: 'Age Range',
    distance: 'Distance',
    showMe: 'Show Me',
    applyFilters: 'Apply Filters',
    like: 'Like',
    pass: 'Pass',
    itsAMatch: "It's a Match!",
    matchMessage: 'You and {name} liked each other!',
    sendMessage: 'Send Message',
    keepSwiping: 'Keep Swiping',
  },
  
  // Messages
  messages: {
    title: 'Messages',
    noMatches: 'No matches yet',
    startMatching: 'Start swiping to find matches',
    typeMessage: 'Type a message...',
    online: 'Online',
    offline: 'Offline',
    translate: 'Translate',
    selectLanguage: 'Select Language',
    translateMessages: 'Translate Messages',
    original: 'Original',
    translated: 'Translated',
    videoCall: 'Video Call',
    voiceCall: 'Voice Call',
  },
  
  // Profile
  profile: {
    title: 'Profile',
    editProfile: 'Edit Profile',
    about: 'About',
    interests: 'Interests',
    photos: 'Photos',
    addPhoto: 'Add Photo',
    deletePhoto: 'Delete Photo',
    saveChanges: 'Save Changes',
    age: 'Age',
    location: 'Location',
    addInterest: 'Add Interest',
    bio: 'Bio',
    editBio: 'Edit Bio',
  },
  
  // Settings
  settings: {
    title: 'Settings',
    account: 'Account',
    privacy: 'Privacy',
    notifications: 'Notifications',
    preferences: 'Preferences',
    security: 'Security',
    help: 'Help',
    language: 'Language',
    
    accountSettings: {
      title: 'Account Information',
      email: 'Email Address',
      phone: 'Phone Number',
      saveChanges: 'Save Changes',
      dangerZone: 'Danger Zone',
      deleteAccount: 'Delete Account',
      deleteWarning: 'This action cannot be undone. All your data will be permanently deleted.',
    },
    
    privacySettings: {
      title: 'Privacy Settings',
      profileVisibility: 'Profile Visibility',
      public: 'Public',
      matchesOnly: 'Matches Only',
      private: 'Private',
      showOnline: 'Show Online Status',
      showOnlineDesc: 'Other users can see when you are online',
      showDistance: 'Show Distance',
      showDistanceDesc: 'Show distance to your location on profile',
    },
    
    notificationSettings: {
      title: 'Notification Settings',
      emailNotifications: 'Email Notifications',
      emailDesc: 'Receive emails for important updates',
      pushNotifications: 'Push Notifications',
      pushDesc: 'Receive notifications on your mobile device',
      matchNotifications: 'Match Notifications',
      matchDesc: 'Get notified about new matches',
      messageNotifications: 'Message Notifications',
      messageDesc: 'Get notified about new messages',
    },
    
    preferenceSettings: {
      title: 'Search Preferences',
      ageRange: 'Age Range',
      maxDistance: 'Maximum Distance',
      showMe: 'Show Me',
      everyone: 'Everyone',
      womenOnly: 'Women Only',
      menOnly: 'Men Only',
      savePreferences: 'Save Preferences',
    },
    
    securitySettings: {
      title: 'Security',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      updatePassword: 'Update Password',
      twoFactor: 'Two-Factor Authentication',
      twoFactorDesc: 'Enable two-factor authentication to make your account more secure.',
      enable: 'Enable',
    },
    
    helpSettings: {
      title: 'Help & Support',
      faq: 'Frequently Asked Questions',
      support: 'Support Team',
      feedback: 'Send Feedback',
      guide: 'User Guide',
    },
    
    languageSettings: {
      title: 'Language Settings',
      selectLanguage: 'Select Language',
      languages: {
        en: 'English',
        tr: 'Türkçe',
        es: 'Español',
        fr: 'Français',
        de: 'Deutsch',
        it: 'Italiano',
        pt: 'Português',
        ru: 'Русский',
        ar: 'العربية',
        zh: '中文',
        ja: '日本語',
        ko: '한국어',
      },
    },
  },
  
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    km: 'km',
    yearsOld: 'years old',
  },
  
  // Footer
  footer: {
    about: 'About Us',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    contact: 'Contact',
    copyright: '© 2024 Love Connect Globimeet. All rights reserved.',
  },
  
  // PWA Installation
  installApp: 'Install LoveConnect App',
  installDescription: 'Get the full app experience with offline access and notifications',
  installInstructions: 'Tap the share button below and select "Add to Home Screen"',
  tapShare: 'Tap Share',
  addToHome: 'Add to Home',
  install: 'Install',
};

export default translation;
